const faqs = [
  {
    question: "Quelle réactivité pour Ostwald ?",
    answer:
      "Ostwald est l'une des communes les plus proches de notre atelier. Pour une urgence, nous intervenons en 2 à 4 heures seulement. Pour une réparation planifiée, nous vous proposons un créneau le jour même ou le lendemain. C'est l'un des délais les plus courts de tout le Bas-Rhin. Appelez-nous au 03 74 47 10 36.",
  },
  {
    question: "Le déplacement est-il facturé à Ostwald ?",
    answer:
      "Non, le déplacement est entièrement gratuit à Ostwald comme dans tout le Bas-Rhin. Nous ne facturons aucun frais de déplacement. Le devis est également gratuit et sans engagement. Le technicien arrive avec son stock de pièces, diagnostique et vous remet un devis détaillé.",
  },
  {
    question: "Quels mécanismes réparez-vous à Ostwald ?",
    answer:
      "Nous réparons tous les mécanismes : oscillo-battant, crémone, poignée, gond, paumelle. Que vous ayez des fenêtres PVC d'immeuble ou des ouvertures en bois de pavillon, nos techniciens emportent les pièces adaptées. Toutes les marques sont prises en charge : Ferco, GU, Roto, Maco, Siegenia, Winkhaus, Vachette et bien d'autres. Chaque pièce remplacée est garantie 10 ans.",
  },
];

export default function FAQ() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-10">
          Questions fréquentes — Ostwald
        </h2>
        <div className="space-y-4 max-w-3xl">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-rose-100 p-5 md:p-6"
            >
              <h3 className="font-serif text-base md:text-lg font-semibold text-plum-dark mb-3">
                {faq.question}
              </h3>
              <p className="text-plum-dark text-sm md:text-base leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}